var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useEffect, useMemo, useRef, useState, } from "react";
import { Pagination } from "react-bootstrap";
import GenericTable from "@frameworks/shared-library/components/GenericTable";
import GenericTableShimmer from "@frameworks/shared-library/components/GenericTableShimmer/GenericTableShimmer";
// used for Internal Data Pagination
var DynamicPagination = function (props) {
    var numOfPages = props.totalNumberPages ||
        Math.ceil(props.data.length / props.dataLengthPerPage);
    var _a = __read(React.useState(props.initPageNumber !== undefined ? props.initPageNumber : 1), 2), currentPage = _a[0], setCurrentPage = _a[1];
    var _b = __read(useState(true), 2), loader = _b[0], setLoader = _b[1];
    var loaderRef = useRef();
    var paginationItems = function () {
        var pages = [];
        var _loop_1 = function (i) {
            pages.push(React.createElement(Pagination.Item, { key: i, active: i === currentPage, onClick: function () {
                    setCurrentPage(i);
                    props === null || props === void 0 ? void 0 : props.setCurrentPage(i);
                } }, i));
        };
        for (var i = 1; i <= numOfPages; i++) {
            _loop_1(i);
        }
        return pages;
    };
    var data = useMemo(function () {
        return props.infinityScroll
            ? props.data.slice(0, currentPage * props.dataLengthPerPage)
            : props.data.slice((currentPage - 1) * props.dataLengthPerPage, currentPage * props.dataLengthPerPage);
    }, [currentPage, props.data.length]);
    var nextPage = useCallback(function () {
        delete props.loader;
        if (currentPage < numOfPages && !!props.manualNext) {
            setLoader(true);
            setCurrentPage(function (page) { return page + 1; });
            setTimeout(function () {
                setLoader(false);
            }, 300);
        }
    }, [currentPage, loader]);
    useEffect(function () {
        if (props.viewAll &&
            (props.manualNext === undefined || props.manualNext === false)) {
            var observer_1 = new IntersectionObserver(function (entries) {
                var target = entries[0];
                if (target.isIntersecting) {
                    nextPage();
                }
            });
            if (loaderRef.current && numOfPages > 1) {
                observer_1.observe(loaderRef.current);
            }
            else {
                setLoader(false);
            }
            return function () {
                if (loaderRef.current) {
                    observer_1.unobserve(loaderRef.current);
                }
            };
        }
    }, [currentPage]);
    return (React.createElement(React.Fragment, null,
        props.Bodycomponent ? (React.createElement(React.Fragment, null,
            React.createElement(props.Bodycomponent, __assign({}, props, { data: props.manualNext
                    ? props.data
                    : props.isPageFromParent
                        ? props.data
                        : data, loaderRef: loaderRef })),
            props.paginationLoader && (React.createElement(GenericTableShimmer, { rowCount: 10, columnCount: 8, columnsWidthClass: "table-shimmer-col-fr2-1-1-1-1-1-1-1_2" })))) : (props.data &&
            props.data.length > 0 && (React.createElement(GenericTable, __assign({}, props, { data: data, callbackSorted: props.callbackSorted, selectedSortColumnVal: props.selectedSortColumnVal, selectedSortVal: props.selectedSortVal, sortIconUp: props.sortIconUp, sortIconDown: props.sortIconDown })))),
        !props.infinityScroll && (React.createElement(Pagination, { className: "dynamic-pagination ".concat(props.paginationClassname && props.paginationClassname) },
            props.prev && currentPage > 1 && (React.createElement(Pagination.Prev, { className: "arrow-button left", onClick: function () { return setCurrentPage(currentPage - 1); } },
                React.createElement("i", { className: "edel-icon-arrow-left" }))),
            paginationItems(),
            props.next && (React.createElement(Pagination.Next, { className: "arrow-button right", onClick: function () { return setCurrentPage(currentPage + 1); }, disabled: currentPage === numOfPages },
                React.createElement("i", { className: "edel-icon-arrow-right" }))))),
        props.viewAll && props.infinityScroll && props.manualNext && (React.createElement(Pagination, { className: "dynamic-pagination ".concat(props.paginationClassname && props.paginationClassname) },
            React.createElement(Pagination.Next, { className: "arrow-button right", onClick: function () {
                    return setCurrentPage(function (page) {
                        var nextPage = props.isPageFromParent
                            ? props.initPageNumber
                            : page + 1;
                        props.nextFunction && props.nextFunction(nextPage);
                        return nextPage;
                    });
                }, disabled: currentPage === numOfPages },
                React.createElement("button", { className: "btn d-flex align-items-center btn-load-more gap-1" },
                    React.createElement("p", { className: "DMSan_16_400" }, "Load More"),
                    React.createElement("i", { className: "d-flex edel-icon-arrow-down" }))))),
        (props === null || props === void 0 ? void 0 : props.customLoadMore) && props.infinityScroll && props.manualNext && React.createElement(Pagination, { className: "dynamic-pagination ".concat(props.paginationClassname && props.paginationClassname) },
            React.createElement(Pagination.Next, { className: "arrow-button right", onClick: function () {
                    return setCurrentPage(function (page) {
                        var nextPage = props.isPageFromParent
                            ? props.initPageNumber
                            : page + 1;
                        props.nextFunction && props.nextFunction(nextPage);
                        return nextPage;
                    });
                }, disabled: currentPage === numOfPages },
                React.createElement("button", { className: "btn d-flex align-items-center btn-load-more gap-1" },
                    React.createElement("p", { className: "DMSan_16_400" }, "Load More"),
                    React.createElement("i", { className: "d-flex edel-icon-arrow-down" }))))));
};
export default DynamicPagination;
